import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowRightLarge = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor' }, forwardedRef) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '17px', height: '14px' }}
      viewBox="0 0 17 14"
      fill="none"
      ref={forwardedRef}
    >
      <path
        d="M1.39551 6.99995H15.2979M15.2979 6.99995L9.55783 1.20728M15.2979 6.99995L9.55783 12.7926"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  )
})

export default ArrowRightLarge
